export const getColorByPercentage = (
    startColor: string, 
    endColor: string, 
    percentage: number
  ): string => {
    // Convert hex to RGB
    const hexToRgb = (hex: string) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    };

    // Convert RGB to hex
    const rgbToHex = (r: number, g: number, b: number) => {
      return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    };

    const start = hexToRgb(startColor);
    const end = hexToRgb(endColor);

    if (!start || !end) return startColor;

    // Clamp percentage between 0 and 1
    const p = Math.max(0, Math.min(1, percentage / 100));

    // Interpolate between colors
    const r = Math.round(start.r + (end.r - start.r) * p);
    const g = Math.round(start.g + (end.g - start.g) * p);
    const b = Math.round(start.b + (end.b - start.b) * p);

    return rgbToHex(r, g, b);
  }